import React, { useCallback, forwardRef } from 'react';
import { NavigationItemWrapper, NavigationWrapper } from './styles';
import { useHistory } from 'react-router-dom';
import BottomNavigationItem from './bottomNavigationItem';
import useKeyboardVisibility from '../../../global/useKeyboard';
import { ROUTES } from '../../../routes/urls';

interface Props {
  backNavigationPath?: string;
  rightElement?: React.ReactNode;
  handleBackIcon?: () => void;
  centerElement?: React.ReactNode;
  isMessage?: boolean;
  isKeyboardVisible?: boolean;
  disableKeyboardHide?: boolean;
}

const SubNavigation = forwardRef<HTMLDivElement, Props>(
  (
    {
      backNavigationPath,
      rightElement,
      handleBackIcon,
      centerElement,
      isMessage,
      isKeyboardVisible,
      disableKeyboardHide
    },
    ref
  ) => {
    //Other variables
    const history = useHistory();
    const keyboardOpen = useKeyboardVisibility();

    const onClickBackIcon = useCallback(() => {
      if (handleBackIcon) {
        handleBackIcon();
      } else if (backNavigationPath) {
        history.push(backNavigationPath);
      } else if (history.length > 1) {
        history.goBack();
      } else {
        history.push(ROUTES.INBOX);
      }
    }, [handleBackIcon, backNavigationPath, history]);

    if (keyboardOpen && !isMessage && !disableKeyboardHide) {
      return null;
    }

    return (
      <NavigationWrapper ref={ref}>
        <div className='left-gradient' />
        {!(isKeyboardVisible && isMessage) && (
          <NavigationItemWrapper>
            <BottomNavigationItem iconName='back-navigation-arrow' onClick={onClickBackIcon} />
          </NavigationItemWrapper>
        )}
        {centerElement}
        {rightElement && !(isKeyboardVisible && isMessage) && (
          <NavigationItemWrapper>{rightElement}</NavigationItemWrapper>
        )}
      </NavigationWrapper>
    );
  }
);

export default SubNavigation;
